import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import style from '../reducer/style'
import user from '../reducer/user'
import artist from '../reducer/artist'

const createRootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    style,
    user,
    artist
  })
export default createRootReducer
